<svg
  width="24"
  height="24"
  class="shrink-0"
  viewBox="0 0 24 24">
  <use class="fill-current" [attr.xlink:href]="SvgSpriteIcon.Cookie"></use>
</svg>

<div class="content">
<ng-content/>
</div>

<p>
  By clicking 'Accept,' you agree to the use of these cookies. You can withdraw your consent at any time by
  contacting us or adjusting your browser settings
</p>
<div class="buttons">
  <button type="button" (click)="onConsentGranted.emit()">
    {{ acceptLabel() }}
  </button>
  <button class="secondary" type="button" (click)="onRejected.emit()">
    {{ denyLabel() }}
  </button>
</div>
